
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/store-locator",
      function () {
        return require("private-next-pages/[lang]/store-locator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/store-locator"])
      });
    }
  